export default __webpack_public_path__ + "static/media/river.ea16765b.png";